import { FC, useEffect, useState } from 'react';
import { defineMessages, useIntl } from 'react-intl';
import { IconGroupAdd } from '../../icons';
import Tooltip from '../Tooltip';
import IconButton from '../core/IconButton';
import Input from '../core/Input';
import { Popover, PopoverContent, PopoverTrigger } from '../core/Popover';

interface GroupAddPopoverProps {
  onCreate: (name: string) => void;
}

const messages = defineMessages({
  newGroupName: {
    id: 'schema_management_dialog.new_group_name',
    defaultMessage: 'New group name',
  },
  createNewGroup: {
    id: 'schema_management_dialog.create_new_group',
    defaultMessage: 'Create new group',
  },
});

const GroupAddPopover: FC<GroupAddPopoverProps> = ({ onCreate }) => {
  const intl = useIntl();
  const [open, setOpen] = useState(false);
  const [value, setValue] = useState('');

  useEffect(() => {
    if (!open) {
      setValue('');
    }
  }, [open]);

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <Tooltip label={intl.formatMessage(messages.createNewGroup)}>
        <PopoverTrigger asChild>
          <IconButton
            variant="ghost"
            icon={<IconGroupAdd />}
            aria-label={intl.formatMessage(messages.createNewGroup)}
          />
        </PopoverTrigger>
      </Tooltip>
      <PopoverContent align="start" disablePortal className="px-2 pb-2 pt-7">
        <Input
          id="schema-management-new-group-name"
          autoFocus
          label={intl.formatMessage(messages.newGroupName)}
          value={value}
          onChange={(e) => setValue(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === 'Enter' && value.trim().length > 0) {
              onCreate(value.trim());
              setOpen(false);
            }
          }}
        />
      </PopoverContent>
    </Popover>
  );
};

export default GroupAddPopover;
